import React, { useState } from "react";

import RecruitDate from "./RecruitDate";

import { VoteDateContextProvider } from "contexts/VoteDate";
const Index = props => {
  const SwitchComponents = ({ active, children }) => {
    return children.filter(child => child.props.name === active);
  };
  // Local State
  const [pageProps, setPageProps] = useState({
    active: "RecruitDate",
    props: null
  });

  return (
    <VoteDateContextProvider>
      <SwitchComponents active={pageProps.active}>
        <RecruitDate
          name="RecruitDate"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
        <></>
      </SwitchComponents>
    </VoteDateContextProvider>
  );
};

export default Index;
